import "../../../../styles/workspace_styles/RootUserStyles/SystemAdministrators/DeleteSystemAdministrator.css";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../AppProvider";
import { SystemAdministratorContext } from "./SystemAdministratorProvider";
import { usersMicroserviceUrl } from "../../../../microservices/users_microservice";

const DeleteSystemAdministrator = () =>{
    const {user,logout} = useContext(AppContext);
    const {
        setReloadSystemAdministrators,
        selectedToDeleteSystemAdministrator,setSelectedToDeleteSystemAdministrator
    } = useContext(SystemAdministratorContext);
    const [tenantAdministratorsCount,setTenantAdministatorsCount] = useState(null);
    const [deletingSystemAdministratorStatus,setDeletingSystemAdministratorStatus] = useState('');
    const fetchAndSetTenantAdministratorsCount = async() =>{
        try{
            const url = `${usersMicroserviceUrl}/root/system-admins/${selectedToDeleteSystemAdministrator?.id}/tenants/count`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok) setTenantAdministatorsCount((await response.json()).count);
            else if(response.status === 401) logout();
        }
        catch(error){
            console.error('An error occurred when retrieving the number of tenant administrators created by this system adminisrator',error);
        }
    };
    const deleteSystemAdministrator = async() =>{
        try{
            setDeletingSystemAdministratorStatus('deleting');
            const url = `${usersMicroserviceUrl}/root/system-admins/${selectedToDeleteSystemAdministrator?.id}`;
            const response = await fetch(url,{
                method:'DELETE',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok){
                setDeletingSystemAdministratorStatus('deleted');
                setReloadSystemAdministrators(true);
                return;
            }
            else if(response.status === 401){
                logout();
                return;
            }
        }
        catch(error){
            console.error('Unexpected error occurred when deleting system administrator',error);
        }
        setDeletingSystemAdministratorStatus('delete-error');
    };
    useEffect(() =>{
        if(selectedToDeleteSystemAdministrator){
            document.title = 'Blink IOT | Delete system administrator';
            fetchAndSetTenantAdministratorsCount();
        }
        else{
            document.title = 'Blink IOT | System administrators';
            setDeletingSystemAdministratorStatus('');
        }
    },[selectedToDeleteSystemAdministrator]);
    useEffect(() => {
        const handleEsc = (e) => {
            if(e.key === "Escape" && deletingSystemAdministratorStatus !== 'deleting') setSelectedToDeleteSystemAdministrator(null);
        };
        document.addEventListener("keydown",handleEsc);
        return () => {
            document.removeEventListener("keydown",handleEsc);
        };
    },[selectedToDeleteSystemAdministrator,deletingSystemAdministratorStatus]);
    if(!selectedToDeleteSystemAdministrator) return null;
    return(
        <div className="root-user-delete-system-administrator-parent-container">
            {isNaN(Number(tenantAdministratorsCount)) || Number(tenantAdministratorsCount) !== 0?
                (
                    <div className="root-user-delete-system-administrator-tenant-admins-present-container">
                        <h1>Cannot delete this system administrator</h1>
                        <p>
                            This system administrator has {tenantAdministratorsCount} tenant administrator{tenantAdministratorsCount === 1 ? '' : 's'}.<br/>
                            Please delete all tenant administrators they have created before attempting deletion.
                        </p>
                        <div className="root-user-delete-system-administrator-tenant-admins-present-okay-button-container">
                            <button onClick={() => setSelectedToDeleteSystemAdministrator(null)}>Okay</button>
                        </div>
                        <div className="root-user-delete-system-administrator-tenant-admins-present-escape-button-container"
                            onClick={() => setSelectedToDeleteSystemAdministrator(null)}>
                                <button>&#10006;</button>
                                <p>ESC</p>
                        </div>
                    </div>
                ):deletingSystemAdministratorStatus === ''?
                (
                    <div className="root-user-delete-system-administrator-container">
                        <h1>Delete system administrator "{selectedToDeleteSystemAdministrator?.firstName} {selectedToDeleteSystemAdministrator?.lastName}"?</h1>
                        <p>Once deleted, this system administrator cannot be recovered</p>
                        <div className="root-user-delete-system-administrator-buttons-container">
                            <button className="cancel-delete-button"
                                onClick={() => setSelectedToDeleteSystemAdministrator(null)}>
                                Don't delete
                            </button>
                            <button className="delete-button" onClick={() => deleteSystemAdministrator()}>
                                Delete system administrator
                            </button>
                        </div>
                        <div className="root-user-delete-system-administrator-escape-button-container"
                            onClick={() => setSelectedToDeleteSystemAdministrator(null)}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):deletingSystemAdministratorStatus === 'deleting'?
                (
                    <div className="root-user-deleting-system-administrator-container">
                        <div></div>
                        <p>Deleting system administrator. Please wait...</p>
                    </div>
                ):deletingSystemAdministratorStatus === 'deleted'?
                (
                    <div className="root-user-deleted-system-administrator-container">
                        <h1>System administrator deleted</h1>
                        <p>System administrator "{selectedToDeleteSystemAdministrator.firstName} {selectedToDeleteSystemAdministrator?.lastName}" deleted successfully.</p>
                        <div className="root-user-deleted-system-administrator-okay-button-container">
                            <button onClick={() => setSelectedToDeleteSystemAdministrator(null)}>Okay</button>
                        </div>
                        <div className="root-user-deleted-system-administrator-escape-button-container"
                            onClick={() => setSelectedToDeleteSystemAdministrator(null)}>
                                <button>&#10006;</button>
                                <p>ESC</p>
                        </div>
                    </div>
                ):
                (
                    <div className="root-user-system-administrator-delete-error-container">
                        <h1>Error</h1>
                        <p>Unexpected error occurred when deleting system administrator "{selectedToDeleteSystemAdministrator?.firstName} {selectedToDeleteSystemAdministrator?.lastName}"</p>
                        <div className="root-user-system-administrator-delete-error-okay-button-container">
                            <button onClick={() => setSelectedToDeleteSystemAdministrator(null)}>Okay</button>
                        </div>
                        <div className="root-user-system-administrator-delete-error-escape-button-container"
                            onClick={() => setSelectedToDeleteSystemAdministrator(null)}>
                                <button>&#10006;</button>
                                <p>ESC</p>
                        </div>
                    </div>
                )
            }
        </div>
    );
};
export default DeleteSystemAdministrator;